class GalleryLightbox {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.container = document.getElementById(`GallerySlider-${sectionId}`);
    this.dialog = document.getElementById(`Lightbox-${sectionId}`);
    
    // Explicitly check for elements
    if (!this.container || !this.dialog) return;

    this.closeBtn = this.dialog.querySelector('.lightbox-close');
    this.prevBtn = this.dialog.querySelector('.lightbox-prev');
    this.nextBtn = this.dialog.querySelector('.lightbox-next');
    this.lightboxImg = this.dialog.querySelector('.lightbox-image');
    
    this.galleryImages = Array.from(this.container.querySelectorAll('.gallery-image'));
    this.currentIndex = 0;

    this.init();
  }

  init() {
    this.galleryImages.forEach((img, index) => {
      img.addEventListener('click', (e) => {
        if (!e.target.closest('.gallery-image-wrapper')) return;
        this.updateLightboxImage(index);
        this.dialog.showModal();
      });
    });

    if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.updateLightboxImage(this.currentIndex - 1);
        });
    }

    if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.updateLightboxImage(this.currentIndex + 1);
        });
    }

    this.dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        this.updateLightboxImage(this.currentIndex - 1);
      } else if (e.key === 'ArrowRight') {
        this.updateLightboxImage(this.currentIndex + 1);
      }
    });

    if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.dialog.close();
        });
    }

    this.dialog.addEventListener('click', (e) => {
      if (e.target === this.dialog) {
        this.dialog.close();
      }
    });
  }

  updateLightboxImage(index) {
    if (!this.galleryImages || this.galleryImages.length === 0) return;

    if (index < 0) index = this.galleryImages.length - 1;
    if (index >= this.galleryImages.length) index = 0;
    
    this.currentIndex = index;
    const img = this.galleryImages[this.currentIndex];
    
    if (this.lightboxImg && img) {
        // Prefer data-full-src if available, fallback to src
        let fullSrc = img.dataset.fullSrc || img.src;
        this.lightboxImg.src = fullSrc;
    }
  }
}

document.querySelectorAll('.gallery-slider-section').forEach(section => {
  const sectionId = section.dataset.sectionId;
  if(sectionId) new GalleryLightbox(sectionId);
});
